<div class="user-panel" *ngIf="identityService.user != null">
    <div class="user-info" >
        <div class="image-container">
            <div class="user-image"></div>
        </div>
        <div class="user-name">{{identityService.user.FirstName}} {{identityService.user.LastName}} </div>
    </div>
    <dx-context-menu
        *ngIf="menuMode === 'context'"
        [items]="menuItems"
        target=".user-button"
        showEvent="dxclick"
        width="170px"
        [position]="{ my: 'top center', at: 'bottom center' }"
        cssClass="user-menu">
    </dx-context-menu>
    <dx-list
        *ngIf="menuMode === 'list'"
        class="dx-toolbar-menu-action"
        [items]="menuItems">
    </dx-list>
</div>
